import { Check, X } from "lucide-react";
import { cn } from "@/shared/lib/cn";
import { labelClass } from "@/shared/ui/core/styles";

export type PassFailValue = "Pass" | "Fail" | null;

type Props = {
  label?: string;
  required?: boolean;
  value: PassFailValue;
  onChange: (v: PassFailValue) => void;
  disabled?: boolean;
  error?: string;
};

/**
 * Field capture — 2 nút lớn Pass | Fail tối ưu cho Mobile.
 * Màu sắc chuẩn Design System (brand primary & danger), dịu mắt, icon đồng đều.
 */
export function PassFailControl({
  label,
  required = false,
  value,
  onChange,
  disabled,
  error,
}: Props) {
  return (
    <div className="flex w-full flex-col gap-1.5">
      {label ? (
        <span className={cn(labelClass, "flex items-center gap-1")}>
          <span>{label}</span>
          {required ? (
            <span
              className="text-sm font-bold leading-none text-danger"
              aria-hidden="true"
            >
              *
            </span>
          ) : null}
        </span>
      ) : null}
      <div className="grid grid-cols-2 gap-2.5">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange("Pass")}
          className={cn(
            "flex min-h-11 items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold transition-all select-none border cursor-pointer",
            value === "Pass"
              ? "bg-success text-white border-success shadow-xs"
              : "bg-surface border-border text-text-secondary hover:bg-surface-raised hover:text-text active:bg-surface-raised",
            disabled && "opacity-50 cursor-not-allowed",
          )}
        >
          <Check className="size-4 shrink-0 stroke-[2.5]" aria-hidden="true" />
          <span>Đạt</span>
        </button>

        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange("Fail")}
          className={cn(
            "flex min-h-11 items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold transition-all select-none border cursor-pointer",
            value === "Fail"
              ? "bg-danger text-white border-danger shadow-xs"
              : "bg-surface border-border text-text-secondary hover:bg-surface-raised hover:text-text active:bg-surface-raised",
            disabled && "opacity-50 cursor-not-allowed",
          )}
        >
          <X className="size-4 shrink-0 stroke-[2.5]" aria-hidden="true" />
          <span>Không đạt</span>
        </button>
      </div>
      {error ? (
        <p className="m-0 text-caption text-danger" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
